import { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import aboutStyle from './aboutContent.module.css'

import React from 'react'
import { Helmet } from 'react-helmet';

function AboutMe() {
    let justToTest = 0;
    const timing = setTimeout(() => {
        if (!document.getElementById('about Me').classList.contains('active')) {
            document.getElementById("about Me").className += 'active';
        }
    }, 100);

    if (justToTest === 5) {
        clearTimeout(timing)
    }

    const [contMe, setContMe] = useState('');
    fetch('https://raw.githubusercontent.com/coderaman07/coderaman07/master/Readme.md').then(res => res.text()).then(text2 => setContMe(text2))
    return (
        <div className='text-11 py-5'>
            <Helmet>
                <title>
                    About Me | Down the Code - Blogs for Developers
                </title>
                <meta name="description" content="I am Aman Ojha and I like to develop and write technical blogs to give you a thorough guide of the skills which you think it's hard to learn in a most easy way." />
                <meta name="keywords" content="coding, blog, react, react js, python, python3, django, restful api, developer, developement, flutter, next, next js, react.js, next.js, python 3, server, deployment, java, javascript, dev, hashnode, blogging" />
                <meta property="og:site_name" content="Down the Code | Blog for Developers" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://downthecode.netlify.app" />
                <meta property="og:description" content="I am Aman Ojha and I like to develop and write technical blogs to give you a thorough guide of the skills which you think it's hard to learn in a most easy way." />
                <meta property="og:title" content="Home" />
            </Helmet>
            <div className='image mb-sm-5 mb-4'>
                <img src="https://amanojha.pythonanywhere.com/media/Aman_Ojha.jpg" style={{ height: `50em`, width: `82em` }} className='img-fluid radius-image-full' alt="Aman Ojha" />
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-lg-8">
                        <div className={aboutStyle.aboutContent}>
                            <p><ReactMarkdown children={contMe} className="line-break" /></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutMe

